<ng-container *ngIf="policy?.policyStatus !== 'CANCELLED'">
        <div class="error-notice" *ngIf="!hideAlertNonCancelled">
            <div class="icon">
                <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
            </div>
            <div class="notice-main-row">
                <div class="policy-notice-infor">
                    <div class="bn-policy-title-sec">
                        <div class="notice-text dm-sans-medium">
                            {{ 'Cancellation notice for' }}
                            <ng-container *ngIf="policyCancellationReason.toLowerCase() === 'pay - non-payment of insurance premium' && isAcmic">
                                {{ 'Non-payment of insured premium' }}
                            </ng-container>
                            <ng-container *ngIf="policyCancellationReason.toLowerCase() === 'pay - non-payment of insurance premium' && !isAcmic">
                                {{ 'Non-payment of insurance premium' }}
                            </ng-container>
                            <ng-container *ngIf="policyCancellationReason.toLowerCase() === 'fpd - failure to pay deposit'">
                                {{ 'Failure to pay deposit of insurance premium' }}
                            </ng-container>
                        </div>
                        <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                                (click)="onCloseForNonCancelled()" />
                    </div>
                </div>                
                <div>
                        <div class="bn-error-coverage">
                            <div class="mr-3 bn-coverage-tex" [ngClass]="{'bn-coverage-tex-ma': !isAcmic}">Pay <span class="bn-f-w-600">{{amount | currency }}</span> by {{ date | customDateFormat }} to maintain coverage<span *ngIf="!isAcmic">.</span></div>
                            <div><app-bn-paynow-modal [policy]="policy"></app-bn-paynow-modal></div>
                        </div>
                </div>
            </div>
        </div>
</ng-container>


<ng-container *ngIf="policy?.policyStatus === 'CANCELLED'">
        <div class="error-notice" *ngIf="!hideAlertCancelled">
            <div class="icon">
                <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
            </div>
            <div class="notice-main-row">
                <div class="policy-notice-infor">
                    <div class="bn-policy-title-sec">
                        <div class="notice-text dm-sans-medium">
                            <ng-container *ngIf="!policyCancellationReason; else hasCancellationReason">
                                {{ 'Policy has been cancelled' | translate }}
                            </ng-container>
                            <ng-template #hasCancellationReason>
                                {{ 'Policy has been cancelled for' | translate }}
                                <ng-container *ngIf="(policyCancellationReason.toLowerCase() === 'pay - non-payment of insurance premium');
                                                else failurePayDeposit">
                                                <ng-container *ngIf="isAcmic; else maReason">
                                                    {{ 'non-payment of insurance premium' | translate }}
                                                </ng-container>
                                                <ng-template #maReason>
                                                    {{ 'non-payment of insurance premium' | translate }}
                                                </ng-template>
                                </ng-container>
                                <ng-template #failurePayDeposit>
                                    <ng-container *ngIf="(policyCancellationReason.toLowerCase() === 'fpd - failure to pay deposit'); 
                                                    else otherReason">
                                                    <ng-container *ngIf="isAcmic; else maReason">
                                                        {{ 'Failure to pay deposit of insurance premium' }}
                                                    </ng-container>
                                                    <ng-template #maReason>
                                                        {{ 'Failure to pay deposit of insurance premium' }}
                                                    </ng-template>
                                    </ng-container>
                                </ng-template>
                                <ng-template #otherReason>
                                    <ng-container *ngIf="isAcmic; else maReason">
                                        {{ policyCancellationReason }}
                                    </ng-container>
                                    <ng-template #maReason>
                                        {{ policyCancellationReason }}
                                    </ng-template>
                                </ng-template>
                            </ng-template>
                        </div>
                            <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                                (click)="onClose()" />
                    </div>
                    
                    
                    <div class="policy-notice-infor" *ngIf="policy.policynumber.policyNumber.length===10">
                        <div class="balance-status">
                            {{ 'Cancellation date:' }} <span class="bn-cancellation-value"> {{ date | customDateFormat }}</span>
                        </div>
                        <div class="balance-status" *ngIf="policy?.originalCancelAmount?.theAmount!==0">
                            {{ "Original cancellation amount:" }} <span class="bn-cancellation-value">{{ policy?.originalCancelAmount?.theAmount | currency
                                }}</span>                    
                        </div>
                    </div>
                </div>
                <hr class="bn-hr-margin bn-hr-border">
                
                <div class="bn-contact-agent bn-agent-text">
                    <ng-container *ngIf="isAcmic; else maAssistance">
                        <div class="font-weight-500 mb-1">
                                Contact us for assistance
                        </div>
                        <div class="bn-contact-agent-info">
                            <div class="bn-agent-phone mt-0">
                                <div>
                                    {{ 'PHONE' | translate }}
                                </div>
                                <div class="ml-1">
                                    <a href="tel:1-844-295-4500" class="mapfre link red-text red-text-acmic">
                                        {{ '1-844-295-4500' }}</a>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #maAssistance>
                        <div class="font-weight-500 mb-2">
                                Contact your agent for assistance
                        </div>
                        <div class="bn-contact-agent-info">
                            <div>{{ policy?.agent?.agentName }}</div>
                            <div class="bn-agent-phone" *ngIf="agentPhoneNumber">
                                <div>
                                    {{ 'PHONE' | translate }}
                                </div>
                                <div class="ml-1">
                                    <a href="tel:{{agentPhoneNumber}}" class="mapfre link red-text">
                                        {{ agentPhoneNumber | formatPhone }}</a>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    <!-- </ng-template> -->

</ng-container>
